import React, { Component } from "react";
// import Modal from "../components/Modal";
import StagesManager from "../components/StagesManager";
import AddUserForm from "./AddUser/AddUserForm";
import AddUserHome from "./AddUser/AddUserHome";
import AddUserSearch from "./AddUser/AddUserSearch";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import SidebarView from "../components/SidebarView";
// import ButtonAnimated from "../components/buttons/ButtonAnimated";
// import { translate } from "../utils/useful";

class AddUserSidebar extends Component {

  state = {
    // isLoadingRemove: false,
    id: null,
    index: null,
    data: {},
    title: ''
  }

  hideModal = (id, index) => {
    this.addUserSidebar.hideModal()
  }

  showModal = (edit) => {
    this.setState({ edit, data: this.props.initData }, () => {
      this.modal.showModal()
      setTimeout(() => {
        this.initPage(edit)
      }, 10);
    })
  }

  openSidebar = (edit) => {
    // console.log('openSidebar')
    this.setState({ edit, data: this.props.initData }, () => {
      this.addUserSidebar.openSidebar()
      setTimeout(() => {
        this.initPage(edit)
      }, 10);
    })
  }

  initPage = (edit) => {
    if (edit) {
      this.stagesManager.changeStage("form", null, null, true)
    } else {
      this.stagesManager.changeStage("home", null, null, true)
    }
  }

  // hideModal = () => {
  //   this.removeModal.hideModal()
  // }

  onDone = (type) => {
    this.props.onDone(type)
    this.addUserSidebar.hideModal()
  }

  changePage = (key) => {
    if (this.stagesManager) {
      console.log('keyaa', key)
      if (key == 'home') {
        this.setState({ backbtn: false })
      }
      else {
        this.setState({ backbtn: true })
      }
      this.stagesManager.changeStage(key)
    }
  }

  BackStage = () => {
    this.stageManager.lastStage()
    this.setState({ backbtn: false })

  }

  setData = (data, cb) => {
    let newDate = this.state.data
    if (!newDate) {
      newDate = {}
    }
    if (data == null) {
      newDate = null
    } else {
      for (const [key, value] of Object.entries(data)) {
        newDate[key] = value
      }
    }
    this.setState({ data: newDate }, () => {
      if (cb) { cb() }
    })

  }

  closeSidebar = () => {
    this.addUserSidebar.closeSidebar()
  }

  stageChanged = (stage) => {
    this.setState({ currentStage: stage })
    if (this.container) {
      this.container.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  userInvited = (data) => {
    this.hideModal()
    this.props.itemAdded(data)
  }

  itemEdited = (data) => {
    this.hideModal()
    this.props.itemEdited(data)
  }

  setTitle = (title) => {
    this.setState({ title })
  }

  render() {
    return (
      <SidebarView width={this.props.width} zIndex={40} ref={el => this.addUserSidebar = el} isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} widthCondition={{ xs: "50%", sm: "50%", md: '35%', lg: "35%", xl: "25%" }}>
        <div ref={el => this.container = el} className="w-100 h-100 " style={{ backgroundColor: '#fff', overflow: 'auto', }}>
          <StagesManager ref={el => this.stagesManager = el} changeCB={this.stageChanged}>
            {/* <AddPermissionUsers stage={0} stageName="home" /> */}
            <AddUserHome stage={1} stageName="home" initData={this.state.data} onDone={this.onDone} setData={this.setData} BackStage={this.BackStage} setTitle={this.setTitle} title={this.state.title} changePage={this.changePage} colors={this.props.colors} />
            <AddUserSearch stage={1} stageName="search" initData={this.state.data} onDone={this.onDone} setData={this.setData} BackStage={this.BackStage} setTitle={this.setTitle} title={this.state.title} changePage={this.changePage} colors={this.props.colors} userInvited={this.userInvited} actions={this.props.actions} page={this.props.page} headers={this.props.headers} variables={this.props.variables} />
            <AddUserForm stage={1} stageName="form" initData={this.state.data} onDone={this.onDone} setData={this.setData} BackStage={this.BackStage} setTitle={this.setTitle} title={this.state.title} changePage={this.changePage} colors={this.props.colors} userInvited={this.userInvited} itemEdited={this.itemEdited} actions={this.props.actions} hideModal={this.hideModal} edit={this.state.edit} page={this.props.page} headers={this.props.headers} variables={this.props.variables} closeSidebar={this.closeSidebar} />
          </StagesManager>
        </div>
      </SidebarView>
    );
  }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null, { forwardRef: true }
)(AddUserSidebar);
